import { toast as sonner, Toaster } from 'sonner';
import { Ic } from './Ic';

export type ToastType = 'success' | 'error' | 'info';

/** Imperative on purpose: mutation onError handlers and other non-component
 *  code need to raise a toast, which a context hook could not serve.
 *  A thin shim over Sonner so call sites keep the `toast(msg, type)` shape. */
export function toast(message: string, type: ToastType = 'info') {
  if (type === 'error') {
    // Same id → a repeated failure (e.g. a mutation retried) replaces the
    // existing toast instead of stacking copies. Errors linger longer.
    return sonner.error(message, { id: `err:${message}`, duration: 6000 });
  }
  return type === 'success' ? sonner.success(message) : sonner.info(message);
}

/** Mounted once at the root (main.tsx). Sonner owns stacking, swipe,
 *  hover-to-expand, hidden-tab timer pausing and the enter/exit motion;
 *  `unstyled` + classNames hands the visuals to components.css. */
export function AppToaster() {
  return (
    <Toaster
      theme="dark"
      position="bottom-center"
      visibleToasts={3}
      duration={3500}
      offset={24}
      mobileOffset={16}
      gap={8}
      icons={{
        success: <Ic.check className="ic" />,
        error: <Ic.x className="ic" />,
        info: <Ic.zap className="ic" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'toast',
          title: 'toast-title',
          icon: 'toast-icon',
          success: 'is-success',
          error: 'is-error',
          info: 'is-info',
        },
      }}
    />
  );
}
